import React, { useState, useEffect } from 'react'
import Icon from 'components/Safra/Icon';

import Checkbox from "components/CheckboxCustom";
import ReserveDate from "components/Safra/SearchComponents/ReserveDate";
import Passengers from "components/Safra/SearchComponents/Passengers";
import SearchAirport from "components/Safra/SearchAirport"
import { trackFlightSearch } from '../../../utils/analytics';
import { useTranslation } from "contexts/Safra/TranslationContext";
import {
    SearchContainer,
    SearchTitle,
    SearchContent,
    CheckboxRow,
    SearchButton,
    SummaryContainer,
    SummaryContent,
    SummaryTitle,
    SummaryDetails,
    EditButton
} from "./styles";

export default function SearchBarPassage({ info, handleInfo, onSearch }) {
    const { t } = useTranslation();
    const [onlyIda, setOnlyIda] = useState(false)
    const [initialDates, setInitialDates] = useState({ startDate: null, endDate: null })
    const [initialPassengers, setInitialPassengers] = useState({ adults: 1, children: 0, baby: 0, class: 'economy' })
    const [summary, setSummary] = useState({
        route: '',
        dates: '',
        passengers: ''
    })

    const parseISODateLocal = (dateString) => {
        if (!dateString || typeof dateString !== 'string') return null;
        if (dateString.includes('T')) {
            const parsed = new Date(dateString);
            return Number.isNaN(parsed.getTime()) ? null : parsed;
        }
        const [year, month, day] = dateString.split('-').map(Number);
        if (!year || !month || !day) return null;
        return new Date(year, month - 1, day);
    };

    useEffect(() => {
        const onlyDeparture = localStorage.getItem('onlyDeparture');
        if (onlyDeparture === 'true') {
            setOnlyIda(true);
        }

        const from = decodeURIComponent(localStorage.getItem('from-name') || '');
        const to = decodeURIComponent(localStorage.getItem('to-name') || '');
        const fromDate = localStorage.getItem('from-date-formatted') || '';
        const toDate = localStorage.getItem('to-date-formatted') || '';
        
        const rawFromDate = localStorage.getItem('from-date');
        const rawToDate = localStorage.getItem('to-date');

        setInitialDates({
            startDate: parseISODateLocal(rawFromDate),
            endDate: parseISODateLocal(rawToDate)
        });

        const adults = parseInt(localStorage.getItem('adults')) || 1;
        const children = parseInt(localStorage.getItem('children')) || 0;
        const infants = parseInt(localStorage.getItem('baby')) || 0;
        const cabinClass = localStorage.getItem('class') || 'economy';

        setInitialPassengers({
            adults,
            children,
            baby: infants,
            class: cabinClass
        });

        const totalPassengers = adults + children + infants;
        const passengerText = totalPassengers > 1 
            ? `${totalPassengers} ${t('safra.components.search_bar.travellers')}` 
            : `${totalPassengers} ${t('safra.components.search_bar.traveller')}`;

        setSummary({
            route: from && to ? `${from} → ${to}` : t('safra.components.search_bar.select_route'),
            dates: fromDate ? (toDate ? `${fromDate} ${t('safra.common.to')} ${toDate}` : `${fromDate}`) : t('safra.components.search_bar.select_dates'),
            passengers: passengerText
        });
    }, [info, t])

    const handleOnlyIda = (e) => {
        const checked = e.target.checked
        setOnlyIda(checked)

        try {
            localStorage.setItem('onlyDeparture', checked ? 'true' : 'false')
        }
        catch (err) {
            console.error('Error setting localStorage items for onlyDeparture:', err);
        }

        if (checked) {
            localStorage.setItem('to-date', '')
            localStorage.setItem('to_date', '')
            localStorage.setItem('to-date-formatted', '')

            const checkout = document.getElementById('passCheckout')
            if (checkout) checkout.value = ''
        }
    }

    const handleSearch = () => {
        const adults = parseInt(localStorage.getItem('adults')) || 1;
        const children = parseInt(localStorage.getItem('children')) || 0;
        const baby = parseInt(localStorage.getItem('baby')) || 0;

        trackFlightSearch({
            departure: localStorage.getItem('from-name') || '',
            arrival: localStorage.getItem('to-name') || '',
            depating: localStorage.getItem('from-date-formatted') || '',
            returning: localStorage.getItem('to-date-formatted') || '',
            passengers: adults + children + baby,
            class: localStorage.getItem('class') || '',
            type: onlyIda ? 'Ida' : 'Retorno',
            adults,
            children,
            baby
        });

        if (handleInfo) handleInfo();
        
        if (onSearch) {
            onSearch();
        } else {
            window.location.reload();
        }
    }

    if (info) {
        return (
            <SummaryContainer onClick={handleInfo} role="button" aria-label={t('safra.components.search_bar.edit_aria_label')} tabIndex={0}>
                <SummaryContent>
                    <SummaryTitle>{summary.route}</SummaryTitle>
                    <SummaryDetails>{summary.dates} • {summary.passengers}</SummaryDetails>
                </SummaryContent>
                <EditButton>{t('safra.components.search_bar.edit')}</EditButton>
            </SummaryContainer>
        )
    }

    return (
        <SearchContainer>
            <SearchTitle>{t('safra.components.search_bar.new_flight_search')}</SearchTitle>

            <SearchContent>
                <SearchAirport
                    placeholder=''
                    tipo='origem'
                    id='passOrigem'
                    defaultValue={decodeURIComponent(localStorage.getItem('from-name') || '')}
                />

                <SearchAirport
                    placeholder=''
                    tipo='destino'
                    id='passDestino'
                    defaultValue={decodeURIComponent(localStorage.getItem('to-name') || '')}
                />

                <CheckboxRow>
                    <Checkbox id='chkIda' checked={onlyIda} onChange={handleOnlyIda} label={t('safra.components.search_bar.only_one_way')} />
                </CheckboxRow>

                <ReserveDate
                    iconStart={<Icon name="calendar" size={20} />}
                    iconEnd={<Icon name="calendar" size={20} />}
                    placeholderStart={t('safra.home.fields.departure')}
                    placeholderEnd={t('safra.home.fields.return')}
                    page="airfare"
                    onlyIda={onlyIda}
                    travel={true}
                    initialDates={initialDates}
                    boxed={true}
                />

                <Passengers 
                    initialAdults={initialPassengers.adults}
                    initialChildren={initialPassengers.children}
                    initialBaby={initialPassengers.baby}
                    initialClass={initialPassengers.class}
                    boxed={true}
                />

                <SearchButton onClick={handleSearch} aria-label={t('safra.components.search_bar.search_aria_label')}>
                    {t('safra.home.cta_passagens')}
                </SearchButton>

                <div style={{ display: 'flex', justifyContent: 'center', width: '100%' }} onClick={handleInfo}>
                    <div style={{
                        width: '44px',
                        height: '32px',
                        border: '1px solid #C6C6C5',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        cursor: 'pointer'
                    }}>
                        <Icon name="chevron-up" size={12} color="var(--text-color)" />
                    </div>
                </div>
            </SearchContent>
        </SearchContainer>
    )
}
